import React from 'react'
import CTA from './CTA'
import HeaderSocial from './HeaderSocials'
import hoodiMe from '../../assets/darkblue-hoodi.jpeg'
import './header.css'

const Header = () => {
  return (
    <header id='home' className='card-container'>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Tejas Patne</h1>
        <h5 className="text-light">Fullstack developer & ML enthusiast</h5>
        <CTA />
        <HeaderSocial />
        {/* <div className="me"> */}
          {/* <img src={me} alt="my image" /> */}
          <section>
            <div className='wrapper'>
              <div className="box" style={{ backgroundImage: hoodiMe }}></div>
            </div>
          </section>
        {/* </div> */}

        <a href="#contact" className='scroll__down'>Scroll Down</a>
        
      </div>
    </header>
  )
}

export default Header